import React from "react";
import { Hero } from "./components/Hero";
import { Testimonials } from "./components/Testimonials";
import { PainPoints } from "./components/PainPoints";
import { Audience } from "./components/Audience";
import { SystemOverview } from "./components/SystemOverview";
import { Tomos } from "./components/Tomos";
import { Bonuses } from "./components/Bonuses";
import { CostComparison } from "./components/CostComparison";
import { OfferSection } from "./components/OfferSection";
import { PremiumCompare } from "./components/PremiumCompare";
import { Guarantee } from "./components/Guarantee";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { StickyCta } from "./components/StickyCta";
import { PlanProvider } from "./contexts/PlanContext";
import { PurchaseToast } from "./components/PurchaseToast";
export function App() {
  return <PlanProvider data-id="element-0" data-mp="23utbk3a460as">
    <div className="min-h-screen w-full bg-paper" data-id="element-1" data-mp="23t8hsfvmildz">
      <Hero data-id="element-2" data-mp="3ikqyfyb7r257" />
      <main data-id="element-3" data-mp="3iiwasc8k4vxf">
        <Testimonials data-id="element-4" data-mp="3ijfv1zlojwem" />
        <PainPoints data-id="element-5" data-mp="3ihuyy5jpw5en" />
        <Audience data-id="element-6" data-mp="3mlavl1vse5rc" />
        <SystemOverview data-id="element-7" data-mp="3mkrefndynled" />
        <Tomos data-id="element-8" data-mp="3mjzsz5e2v41t" />
        <Bonuses data-id="element-9" data-mp="3mjpyb4i388ps" />
        <CostComparison data-id="element-10" data-mp="3mj6lg27aoaim" />
        <OfferSection data-id="element-11" data-mp="3rbrbcsn2y3gv" />
        <PremiumCompare data-id="element-12" data-mp="3rdki07xp0nov" />
        <Guarantee data-id="element-13" data-mp="3rd18nfm3z7mg" />
        <Faq data-id="element-14" data-mp="3relwkmdx3sbc" />
        <FinalCta data-id="element-15" data-mp="5orh0l86u6j" />
      </main>
      <Footer data-id="element-16" data-mp="4wyzymxdckh" />
      <StickyCta data-id="element-17" data-mp="5gg5d4r3wxg" />
      <PurchaseToast data-id="element-18" data-mp="82jt1oitsae" />
    </div>
    </PlanProvider>;
}